// extracted by mini-css-extract-plugin
module.exports = {"toast":"styles_toast__2WWgk","defaultClose":"styles_defaultClose__TJf2Q"};